import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { collection, getDocs, getFirestore } from 'firebase/firestore'
import { getApp } from 'firebase/app'
import '../assets/css/HomeScreen.css'
import img1 from '../assets/images/01_0.jpg'
import about from '../assets/images/aboutus.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft,
  faArrowRight,
  faMagnifyingGlass
} from '@fortawesome/free-solid-svg-icons'
const DotIndicator = ({ totalSlides, currentSlide }) => {
  return (
    <div className='dot-indicator'>
      {Array.from({ length: totalSlides }).map((_, index) => (
        <span
          key={index}
          className={`dot ${
            index === currentSlide % totalSlides ? 'active' : ''
          }`}
        ></span>
      ))}
    </div>
  )
}

function HomeScreen ({ language }) {
  const db = getFirestore(getApp())
  const [projects, setProjects] = useState([])
  const [currentSlide, setCurrentSlide] = useState(0)
  const navigate = useNavigate()
  useEffect(() => {
    const fetchProjects = async () => {
      const querySnapshot = await getDocs(collection(db, 'Projects'))
      const projectsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      setProjects(projectsList)
    }

    fetchProjects()
  }, [db])
  const handleNextSlide = () => {
    const totalSlides = projects.filter(project => project.showHome).length
    setCurrentSlide((currentSlide + 1) % totalSlides)
  }

  const handlePrevSlide = () => {
    const totalSlides = projects.filter(project => project.showHome).length
    setCurrentSlide((currentSlide - 1 + totalSlides) % totalSlides)
  }

  const handleProjectClick = projectId => {
    navigate(`/projects/${projectId}`)
  }
  const handleArchitetureClick = () => {
    navigate('/projects/ArchitectureScreen')
  }
  const handleInteriorClick = () => {
    navigate('/projects/InteriorScreen')
  }
  const handleConstructionClick = () => {
    navigate('/projects/Constructioncreen')
  }

  return (
    <div>
      <div className='HomeScreen'>
        <div className='home-container'>
          <div className='home-content'>
            <img src={img1} alt='image1' className='content-image img1' />
            <div className='content-text text1'>
              <h1 className='font-bold text-center text-2xl'>
                COMMONS CORE CO,.LTD.
              </h1>
              <h1 className='text-2xl font-bold'>
                {language === 'en' ? 'Vision' : 'วิสัยทัศน์'}
              </h1>
              <p className='home-context font-light'>
                {language === 'en'
                  ? '"Commons Core" operates on the principle of transforming customer needs into aesthetically pleasing and feasible solutions. We emphasize delivering work that is both outstanding and creative by carefully selecting high-quality materials and products while integrating new technologies into every design. Our approach is driven by collaboration between experienced architects and engineers, ensuring excellence in every project.'
                  : '”คอมมอน คอร์” มีแนวคิดและแนวทาง ในการทำงาน โดยการสร้างสรรค์จากความต้องการของลูกค้าสู่ความสวยงามบนความเป็นได้ เราจึงต้องใส่ใจในการทำงานให้ออกมาดูดีและโดดเด่น  และสร้างสรรค์ โดยการคัดสรรวัสดุและผลิตภัณฑ์คุณภาพที่ดี และพัฒนาเทคโนโลยีใหม่ๆ ให้กับทุกๆงานออกแบบ จากความร่วมมือกันระหว่างสถาปนิกและวิศวกรมืออาชีพมากประสบการณ์'}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='home-about'>
        <div className='image-container'>
          <img
            src={about}
            alt='Project'
            className='projects-image opacity-85'
          />
          <h1 className='projects-title'>
            {language === 'en' ? (
              <>
                <span className='about-text'>ABOUT</span>
                <span className='company-name'>COMMONS CORE CO.,LTD.</span>
              </>
            ) : (
              'เกี่ยวกับเรา'
            )}
          </h1>
        </div>
      </div>
      <div className='HomeScreen'>
        <div className='home-container'>
          <div className='about-content'>
            <div className='about-us-text'>
              <h1 className='text-center'>OUR SPECIALIZE</h1>
            </div>
            <div className='box-section'>
              <button className='box' onClick={handleArchitetureClick}>
                <p>ARCHITECTURE</p>
              </button>
              <button className='box' onClick={handleInteriorClick}>
                <p>INTERIOR</p>
              </button>
              <button className='box' onClick={handleConstructionClick}>
                <p>CONSTRUCTION</p>
              </button>
            </div>
            <div className='text-center mt-10 -mb-5'>
              <span className='text-3xl text-gray-400 font-bold'>OUR </span>
              <span className='text-3xl text-black font-bold'>PROJECTS</span>
            </div>
          </div>
        </div>
      </div>
      <div className='home-projects'>
        <div className='projects-list-container'>
          <button onClick={handlePrevSlide}>
            <FontAwesomeIcon icon={faArrowLeft} className='pr-2' />
            PREV
          </button>
          <div className='projects-slider'>
            {projects
              .filter(project => {
                return project.showHome !== false
              })
              .slice(currentSlide, currentSlide + 3)
              .concat(
                projects.slice(
                  0,
                  Math.max(0, currentSlide + 3 - projects.length)
                )
              )
              .map((project, index) => (
                <div
                  key={index}
                  className='project-item'
                  onClick={() => handleProjectClick(project.id)}
                >
                  <h2 className='project-name font-bold'>{project.name}</h2>
                  <p className='project-category'>{project.category}</p>
                  {project.profileImage && (
                    <>
                      <img
                        src={project.profileImage}
                        alt={project.name}
                        className='project-profileimage'
                      />
                      <div className='overlay'>
                        <FontAwesomeIcon
                          icon={faMagnifyingGlass}
                          className='icon'
                        />
                      </div>
                    </>
                  )}
                </div>
              ))}
          </div>

          <button onClick={handleNextSlide} disabled={projects.length <= 3}>
            NEXT
            <FontAwesomeIcon icon={faArrowRight} className='pl-2' />
          </button>
          <DotIndicator
            totalSlides={projects.filter(project => project.showHome).length}
            currentSlide={currentSlide}
          />
        </div>
      </div>
    </div>
  )
}

export default HomeScreen
